import { useEffect, useState, type FC } from 'react';
import logoSvg from './images/logo.svg';
import plusSvg from './images/plus.svg';
import { useLocalStorageState, useMount } from 'ahooks';
import { Modal } from 'antd';
import { Login } from '../../components/Login';
import { userInfoKey } from '../../utils/localStore';
import { ChatBox } from './components/ChatBox';
import { History } from './components/History';
import { clsx } from 'clsx';
import useUrlState from '@ahooksjs/use-url-state';
import './index.css';
import useI18n from '../../hooks/useI18n';
import { Languages, useLanguageStore } from '../../hooks';

export interface IHomePageProps {}

export const HomePage: FC<IHomePageProps> = (props) => {
  const [token] = useLocalStorageState(userInfoKey);

  const [isLogin, setIsLogin] = useState(!!token);

  const { changeLanguage } = useLanguageStore();
  const [urlLang] = useUrlState({ lang: undefined });

  useMount(() => {
    const lang = localStorage.getItem('lang') as Languages;
    const legalLang = lang === 'zh' || lang === 'en';
    if (urlLang.lang) {
      if (!legalLang || !isLogin) {
        changeLanguage(urlLang.lang);
      } else {
        changeLanguage(lang);
      }
    } else {
      const lang = localStorage.getItem('lang') as Languages;
      if (lang === 'zh' || lang === 'en') {
        changeLanguage(lang);
      }
    }
  });

  const [fold, setFold] = useState(false);

  const [open, setOpen] = useState(false);
  const [refreshHistory, setRefreshHistory] = useState(0);

  const [state, setState] = useUrlState({ id: undefined });

  const [selectChatId, setSelectChatId] = useState<number | undefined>(
    state.id ? Number(state.id) : undefined,
  );

  useEffect(() => {
    setState({ id: selectChatId });
  }, [selectChatId]);

  const i18n = useI18n();

  const showHideClassName = {
    ['hide']: fold,
    ['show']: !fold,
  };
  return (
    <div className="w-full h-[100vh] overflow-hidden flex relative">
      <div
        className={`w-[18.5rem] h-full gap-8 flex flex-col bg-[#F2F4F8] ${fold ? 'fold-animation' : 'expand-animation'}`}
      >
        <div
          className="w-[18.5rem] pb-4 p-4 flex gap-4 items-center cursor-pointer"
          onClick={() => setSelectChatId(undefined)}
        >
          <img src={logoSvg} alt="" />
          <div className={clsx('text-base cursor-pointer', showHideClassName)}>
            Carbon AI
          </div>
        </div>
        <div
          className="h-[40px] p-2 ml-4 rounded-3xl bg-[#EAECF0] self-start flex gap-2 items-center cursor-pointer"
          onClick={() => setSelectChatId(undefined)}
        >
          <img src={plusSvg} alt="" />
          {!fold && (
            <div
              className={clsx(
                'text-sm cursor-pointer text-[#04252BA3] mr-2',
                showHideClassName,
              )}
            >
              {i18n('addDialogue')}
            </div>
          )}
        </div>
        <div className="h-full overflow-y-auto">
          <History
            className={clsx(showHideClassName)}
            isLogin={isLogin}
            refreshHistory={refreshHistory}
            selectChat={selectChatId}
            setSelectChat={(e) => setSelectChatId(e)}
          />
        </div>
      </div>

      <div className="h-[100vh] grow">
        <ChatBox
          isLogin={isLogin}
          setIsLogin={setIsLogin}
          setFold={setFold}
          setRefreshHistory={setRefreshHistory}
          selectChatId={selectChatId}
          setSelectChatId={setSelectChatId}
        />
      </div>
      {!isLogin && (
        <div
          className="absolute top-0 left-0 right-0 bottom-0"
          onClick={() => setOpen(true)}
        >
          <Modal
            open={open}
            centered
            footer={null}
            closable={false}
            width="26rem"
          >
            <Login setIsLogin={setIsLogin} />
          </Modal>
        </div>
      )}
    </div>
  );
};
